var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{
    'wc-modal-root': _vm.modals.length > 0,
    'front-most-modal': _vm.modal && _vm.modal.props && _vm.modal.props.isFrontMostModal,
  },on:{"click":function($event){$event.stopPropagation();}}},[_c('transition',{attrs:{"name":"wc-modal"}},[(_vm.modal)?_c(_vm.modal.component,_vm._b({tag:"component",attrs:{"close":_vm.modal.close,"dismiss":_vm.modal.dismiss,"modalMessage":_vm.message}},'component',_vm.modal.props,false)):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }